import React, { useEffect, useState } from "react";
import axios from "axios";
import './interfaceClient.css';

export default function ReservationHistory() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/client/history`);
       setHistory(res.data.history);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };
    fetchHistory();
  }, []);
  

  return (
  <div className="reservation-page">
  <h1 className="reservation-title">Mes réservations</h1>

  {loading && <p>Chargement...</p>}

  {!loading && history.length > 0 && (
    <div className="space-y-4">
      {history.map((item) => (
        <div key={item._id} className="reservation-card">
          <div className="room-header">
            Chambre {item.room.number} — {item.room.type}
          </div>

          <p className="reservation-info">
            <strong>Du :</strong> {new Date(item.checkIn).toLocaleDateString()} <br />
            <strong>Au :</strong> {new Date(item.checkOut).toLocaleDateString()}
          </p>

          <p className="reservation-info">
            <strong>Paiement :</strong>{" "}
            <span
              className={`payment-badge ${
                item.payment.status === "success"
                  ? "payment-success"
                  : item.payment.status === "pending"
                  ? "payment-pending"
                  : "payment-failed"
              }`}
            >
              {item.payment.status}
            </span>
          </p>

          <p className="reservation-info">
            <strong>Montant :</strong> {item.payment.amount} DA
          </p>

          <p className="reservation-date">
            Réservé le {new Date(item.createdAt).toLocaleString()}
          </p>
        </div>
      ))}
    </div>
  )}

  {!loading && history.length === 0 && (
    <p className="empty-history">Vous n'avez encore effectué aucune réservation.</p>
  )}
</div>

  );
}
